if (!customElements.get('vyv-inline-film')) customElements.define('vyv-inline-film', class extends HTMLElement {
 connectedCallback() {
  if (this.controller) return;
  this.controller = new AbortController();
  const signal = this.controller.signal;
  const video = this.querySelector('[data-scene]');
  const toggle = this.querySelector('[data-scene-toggle]');
  const status = this.querySelector('[data-film-status]');
  const fullLink = this.querySelector('[data-open-full-film]');
  const dialog = this.querySelector('dialog');
  const fullFilm = this.querySelector('[data-full-film]');
  const phone = matchMedia('(max-width:767px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  let intent = 'auto';
  let visible = false;
  let loaded = false;
  let blocked = false;
  let sourceVersion = 0;
  const autoAllowed = () => !reduced.matches && !navigator.connection?.saveData;
  const wantsPlay = () => visible && !document.hidden && !dialog?.open && intent !== 'pause' && !blocked && (intent === 'play' || autoAllowed());
  const selectSource = () => {
   const mode = phone.matches ? 'portrait' : 'wide';
   const source = video.dataset[mode];
   if (video.dataset.activeSource === source) return;
   const time = video.currentTime;
   const version = ++sourceVersion;
   video.dataset.activeSource = source;
   video.poster = video.dataset[`${mode}Poster`];
   if (!loaded) return;
   video.pause();
   video.src = source;
   video.addEventListener('loadedmetadata', () => {
    if (version !== sourceVersion) return;
    video.currentTime = Math.min(time, Math.max(0, video.duration - .1));
    reconcile();
   }, {once:true, signal});
   video.load();
  };
  const reconcile = () => {
   if (wantsPlay()) {
    if (!loaded) {
     loaded = true;
     video.src = video.dataset.activeSource;
     video.load();
    }
    video.muted = true;
    video.play().then(() => { if (!wantsPlay()) video.pause(); }).catch(error => {
     if (error.name === 'NotAllowedError') blocked = true;
    });
   } else video.pause();
  };
  const updateControl = () => {
   const playing = !video.paused;
   toggle.querySelector('[data-control-label]').textContent = playing ? 'Pause video' : 'Play video';
   toggle.querySelector('[data-pause-icon]').hidden = !playing;
   toggle.querySelector('[data-play-icon]').hidden = playing;
  };
  video.muted = true;
  video.removeAttribute('controls');
  toggle.hidden = false;
  selectSource();
  updateControl();
  toggle.addEventListener('click', () => {
   intent = video.paused ? 'play' : 'pause';
   blocked = false;
   reconcile();
  }, {signal});
  video.addEventListener('play', updateControl, {signal});
  video.addEventListener('pause', updateControl, {signal});
  video.addEventListener('error', () => {
   status.textContent = 'The video could not load. Please try again.';
   blocked = true;
   updateControl();
  }, {signal});
  phone.addEventListener('change', selectSource, {signal});
  reduced.addEventListener('change', reconcile, {signal});
  navigator.connection?.addEventListener('change', reconcile, {signal});
  document.addEventListener('visibilitychange', reconcile, {signal});
  this.observer = new IntersectionObserver(entries => {
   visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
   reconcile();
  }, {threshold:[0,.2]});
  this.observer.observe(video);
  if (fullLink && dialog && fullFilm) {
   fullLink.addEventListener('click', event => {
    event.preventDefault();
    video.pause();
    dialog.showModal();
    fullFilm.src ||= fullLink.href;
    fullFilm.muted = true;
    fullFilm.play().catch(() => {});
   }, {signal});
   dialog.querySelector('[data-close-film]').addEventListener('click', () => { fullFilm.pause(); dialog.close(); }, {signal});
   dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); }, {signal});
   dialog.addEventListener('close', () => {
    fullFilm.pause();
    fullLink.focus({preventScroll:true});
    reconcile();
   }, {signal});
  }
 }
 disconnectedCallback() {
  this.observer?.disconnect();
  this.controller?.abort();
  this.controller = null;
  this.querySelectorAll('video').forEach(video => video.pause());
 }
});
